module.exports = __webpack_public_path__ + "img/icono_QR.3663f221.png";